// import EntypoIcon from '@expo/vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUISalePageSelectProductView from 'xui/modules/storeWebsite/BaseUISalePageSelectProductView'

export default class SalePageSelectProductView extends BaseUISalePageSelectProductView {}
